// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"7f08c90a","193":"7d8d3f4b","213":"8eb4a99f","242":"5db1617f","432":"af201f4a","449":"aea5f36b","752":"49997b34","778":"5380cb98","847":"8e42d515"}[chunkId] + ".chunk.js";
};